import { render, staticRenderFns } from "./VideoPlayerModule.vue?vue&type=template&id=2d9c80cd&"
import script from "./VideoPlayerModule.ts?vue&type=script&lang=ts&"
export * from "./VideoPlayerModule.ts?vue&type=script&lang=ts&"
import style0 from "./VideoPlayerModule.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports